var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-blue-800 h-full w-full" }, [
    _c(
      "div",
      { staticClass: "container mx-auto px-4 h-full pt-24 min-h-screen" },
      [
        _c(
          "div",
          {
            staticClass:
              "flex content-center items-center justify-center h-full"
          },
          [
            _c("div", { staticClass: "w-full lg:w-7/12 px-4" }, [
              _c(
                "div",
                {
                  staticClass:
                    "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blue-100 border-0"
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex-auto px-4 lg:px-10 py-10 pt-0" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "h6",
                        { staticClass: "font-bold text-center mb-8 text-3xl" },
                        [_vm._v("Sign Up")]
                      ),
                      _vm._v(" "),
                      _c(
                        "form-wizard",
                        {
                          ref: "formWizard",
                          attrs: {
                            shape: "tab",
                            color: "#3498db",
                            title: "",
                            subtitle: ""
                          },
                          on: { "on-complete": _vm.onCompleteSave },
                          scopedSlots: _vm._u([
                            {
                              key: "footer",
                              fn: function(props) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "wizard-footer-left" },
                                    [
                                      props.activeTabIndex > 0
                                        ? _c(
                                            "wizard-button",
                                            {
                                              style: props.fillButtonStyle,
                                              nativeOn: {
                                                click: function($event) {
                                                  return props.prevTab()
                                                }
                                              }
                                            },
                                            [_vm._v("Previous")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "wizard-footer-right" },
                                    [
                                      !props.isLastStep
                                        ? _c(
                                            "wizard-button",
                                            {
                                              staticClass:
                                                "wizard-footer-right",
                                              style: props.fillButtonStyle,
                                              nativeOn: {
                                                click: function($event) {
                                                  return props.nextTab()
                                                }
                                              }
                                            },
                                            [_vm._v("Next")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      props.isLastStep
                                        ? _c(
                                            "wizard-button",
                                            {
                                              staticClass:
                                                "wizard-footer-right finish-button",
                                              class: _vm.isLoading
                                                ? "cursor-not-allowed"
                                                : "",
                                              style: props.fillButtonStyle,
                                              attrs: {
                                                disabled: _vm.isLoading
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  return props.nextTab()
                                                }
                                              }
                                            },
                                            [_vm._v("Create Account")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Account Details",
                                "before-change": function() {
                                  return _vm.validateStep("step1")
                                }
                              }
                            },
                            [
                              _c("FormSignupUser", {
                                ref: "step1",
                                attrs: {
                                  isEmailExist: _vm.isEmailExist,
                                  emailErrorMsg: _vm.emailErrorMsg
                                },
                                on: { "on-validate": _vm.mergePartialModels }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Artist Application",
                                "before-change": function() {
                                  return _vm.validateStep("step2")
                                }
                              }
                            },
                            [
                              _c("FormArtistApplication", {
                                ref: "step2",
                                on: { "on-validate": _vm.mergePartialModels }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-grey-600 mt-6" },
                        [
                          _vm._v(
                            "\n              Already have an account?\n              "
                          ),
                          _c(
                            "router-link",
                            {
                              staticClass:
                                "no-underline border-b border-blue text-blue-600 font-bold",
                              attrs: { to: { path: "/login" } }
                            },
                            [_vm._v("\n                Log in\n              ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: " mb-3" }, [
      _c("img", {
        staticClass: "m-auto",
        staticStyle: { width: "150px" },
        attrs: { src: require("@/assets/musicverse-logo.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-024d905c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-024d905c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Signup.vue
// module id = null
// module chunks = 